import type {
  UserManagementUser,
  UserInvitation,
  AppRole,
} from '../types/organization.types';

export const organizationMappers = {
  mapOrgUserViewRow(row: any): UserManagementUser {
    let status: 'active' | 'inactive' | 'suspended';
    if (!row.is_active) {
      status = 'suspended';
    } else if (row.status === 'active') {
      status = 'active';
    } else {
      status = 'inactive';
    }

    return {
      id: row.user_id || row.id,
      name: row.name || 'Unknown User',
      email: row.email || '',
      role: (row.role || 'talent_manager') as AppRole,
      status,
      created_at: row.joined_at || row.created_at || new Date().toISOString(),
      last_login: row.last_sign_in_at || row.last_login || null,
      organization_role: (row.role || 'talent_manager') as AppRole,
      user_org_id: row.id,
    };
  },

  mapInvitationRow(row: any): UserInvitation {
    return {
      id: row.id,
      email: row.email,
      role: row.role as AppRole,
      status: row.status,
      invited_at: row.invited_at,
      expires_at: row.expires_at,
      accepted_at: row.accepted_at || null,
    };
  },
};
